export default __webpack_public_path__ + "media/images/images/banner/banner-27-feae68547b64be59c10b06d547032214.jpg";